module.exports = __webpack_public_path__ + "img/cover3.9087cc55.jpg";